import { TextField, IconButton, InputAdornment, TextFieldProps } from '@mui/material';
import { debounce } from 'lodash';
import { FC, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Iconify from '../../media/iconify';

type Props = {
  filters: Record<string, any>;
  setFilters: React.Dispatch<React.SetStateAction<any>>;
} & TextFieldProps;

export const SearchTextField: FC<Props> = ({ filters, setFilters, ...others }) => {
  const { t } = useTranslation();
  const searchTextRef = useRef<HTMLInputElement>();

  const handleFilterSearch = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setFilters((prevState: Record<string, any>) => ({
        ...prevState,
        page: 0,
        search: event.target.value,
      }));
    },
    [setFilters]
  );

  return (
    <TextField
      fullWidth
      inputRef={searchTextRef}
      defaultValue={filters.search}
      onChange={debounce(handleFilterSearch, 400)}
      placeholder={t('Search...')}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
          </InputAdornment>
        ),
        endAdornment: (!!searchTextRef?.current?.value?.length || !!filters.search.length) && (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={() => {
                if (searchTextRef?.current) {
                  searchTextRef.current.value = '';
                }
                setFilters((prevState: Record<string, any>) => ({
                  ...prevState,
                  page: 0,
                  search: '',
                }));
              }}
              sx={{ borderRadius: 0.75 }}
            >
              <Iconify icon="octicon:x-12" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...others}
    />
  );
};
